import { render, staticRenderFns } from "./integrationPatients.vue?vue&type=template&id=566fd973&scoped=true&"
import script from "./integrationPatients.vue?vue&type=script&lang=js&"
export * from "./integrationPatients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566fd973",
  null
  
)

export default component.exports